import { apiMoney } from '@ms/utils-es/math'

export const formatTaxParam = (val) => {
  if (val === 0) return 0
  if (!val) return null
  if (Array.isArray(val)) {
    return val.map((x) => apiMoney(x)).join('-')
  } else {
    return apiMoney(val)
  }
}
